<template>
  <header class="df aic jcsb bgh hst header">
    <div class="header-logo" @click="handleGoClient">
      <img src="@/assets/images/frame_logo.png" style="width: 100%; height: 100%" alt="" />
    </div>

    <el-dropdown trigger="click" @command="handleCommand">
      <div v-if="isLoggedIn" class="curp">
        <span style="color: #fff">{{ userInfo.name }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>
      <div v-else class="curp" @click="$router.push({ name: 'Login' })">请登录</div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </header>
</template>

<script>
import { SSO_TOKEN, SSO_USER_INFO, SCANA_CLIENT_HOME } from '@/config'
import { userInfoBus } from '@/bus/bus'
export default {
  name: 'Header',
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.getItem(SSO_USER_INFO)),
    }
  },
  computed: {
    isLoggedIn() {
      const info = window.localStorage.getItem(SSO_TOKEN)
      return info ? true : false
    },
  },
  created() {
    userInfoBus.$on('userinfo-change', (msg) => {
      this.userInfo = msg
    })
  },
  beforeDestroy() {
    userInfoBus.$off('userinfo-change')
  },

  methods: {
    handleCommand(command) {
      switch (command) {
        case 'login': {
          this.$router.push({ name: 'Login' })
          break
        }
        case 'logout': {
          this.$router.push({ name: 'Logout' })
        }
      }
    },
    handleGoClient() {
      window.location.href = SCANA_CLIENT_HOME
    },
    Logout() {},
    Login() {
      this.$router.push({ name: 'Login' })
    },
  },
}
</script>

<style lang="scss">
.header {
  background-color: #1e1f23;
  padding-inline: 10px;
  .header-logo {
    width: 180px;
    cursor: pointer;
  }
}
</style>
